export function agentQAItemInfoRenderer(params: { data?: any }) {
  if (!params.data || !params.data.item_info) {
    return '<span style="color: #999;">N/A</span>';
  }

  const itemInfo = params.data.item_info;
  const agentType = itemInfo.agent_type || '';
  const dialectCode = itemInfo.dialect_code || '';

  // Check if this is a dialog (has segments array)
  if (itemInfo.segments && Array.isArray(itemInfo.segments)) {
    return renderDialogSegments(itemInfo.segments, dialectCode);
  }

  // Single translation display (existing logic)
  const usTranslation = itemInfo.us_translation || '';
  const targetTranslation = itemInfo.target_translation || '';

  // Display EN and dialect for all agent types that have translation data
  if (usTranslation || targetTranslation) {
    return `
      <div style="padding: 6px 0;">
        <div style="
          padding: 6px 10px;
          background-color: #f5f5f5;
          border-left: 3px solid #2196f3;
          border-radius: 3px;
          margin-bottom: 6px;
          line-height: 1.4;
        ">
          <strong>EN:</strong> ${usTranslation || 'N/A'}
        </div>
        <div style="
          padding: 6px 10px;
          background-color: #f5f5f5;
          border-left: 3px solid #4caf50;
          border-radius: 3px;
          line-height: 1.4;
        ">
          <strong>${escapeHtml(dialectCode || 'XX')}:</strong> ${targetTranslation || 'N/A'}
        </div>
      </div>
    `;
  }

  // Fallback for agent types without translation data
  return `
    <div style="padding: 6px 0; color: #666;">
      Agent: ${escapeHtml(agentType)}
    </div>
  `;
}

function renderDialogSegments(segments: any[], dialectCode: string): string {
  let html = '<div style="padding: 6px 0;">';

  segments.forEach((segment, idx) => {
    const speaker = segment.speaker ? ` (${escapeHtml(segment.speaker)})` : '';
    const usText = segment.us_text || '';
    const targetText = segment.target_text || '';

    html += `
      <div style="margin-bottom: ${idx < segments.length - 1 ? '10px' : '0'};">
        <div style="font-size: 11px; color: #666; margin-bottom: 4px; font-weight: 600;">
          Segment ${segment.index}${speaker}
        </div>
        <div style="
          padding: 6px 10px;
          background-color: #f5f5f5;
          border-left: 3px solid #2196f3;
          border-radius: 3px;
          margin-bottom: 4px;
          line-height: 1.4;
          font-size: 12px;
        ">
          <strong>EN:</strong> ${escapeHtml(usText)}
        </div>
        <div style="
          padding: 6px 10px;
          background-color: #f5f5f5;
          border-left: 3px solid #4caf50;
          border-radius: 3px;
          line-height: 1.4;
          font-size: 12px;
        ">
          <strong>${escapeHtml(dialectCode || 'XX')}:</strong> ${escapeHtml(targetText)}
        </div>
      </div>
    `;
  });

  html += '</div>';
  return html;
}

function escapeHtml(text: string): string {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}
